import * as React from 'react'
import LocalizationStore from './../../../Stores/LocalizationStore'
import { observer } from 'mobx-react'

@observer
export default class LanguageSelectorView extends React.Component<any> {
    
    constructor(props: any) {
        super(props)
    }

    render() {
        const ls = LocalizationStore.getInstance()

        return (
            <div className="languageBar">
                <span 
                    className={'lang ru ' + ('RU' === ls.lang ? 'active' : '')} 
                    onClick={() => { ls.setLanguage('RU') }}
                >
                    RU
                </span>
                <span 
                    className={'lang az ' + ('AZ' === ls.lang ? 'active' : '')} 
                    onClick={() => { ls.setLanguage('AZ') }}
                >
                    AZ
                </span>
                {/* <span className="lang en" onClick={() => { this.props.setLanguage('EN') }}>EN</span> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/LanguageSelector/view.tsx